<template>
  <div>

<div class="container " id="container-1">
  <div class="row bar">
        <div class="col-12 col-md-5">
          <div class="d-flex justify-content-between mb-1">
            <div class="col-auto bg-n-red">品質認證</div>
            <div class="col bg-n-gray text-left">QUALITY ASSURANCE</div>

          </div>
        </div>
       
      </div>
  <div class="row my-5">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="(item) in paper" :key="item.id">
      <img :src="item['img']" alt="">
      <p class="px-3 my-2 font-weight-bold">{{item.text}}</p>
    </div>
  </div>
 </div>
      
  </div>
</template>


<script>
export default {
  data(){
    return{

      a: [
        {
          xs: "/static/qualityinsure/768/1.jpg",
          sm: "/static/qualityinsure/768/1.jpg",
          md: "/static/qualityinsure/768/1.jpg",
          lg: "/static/qualityinsure/768/1.jpg",
          xl: "/static/qualityinsure/1200/1.jpg"
        }
      ],
      paper:[
        {img:"/static/qualityinsure/1200/2.jpg",text:"LED三色燈防塵與防水測試報告"},
        {img:"/static/qualityinsure/1200/3.jpg",text:"LED串燈防塵與防水測試報告"},
        {img:"/static/qualityinsure/1200/4.jpg",text:"LED扁珠燈防塵與防水測試報告"},
        {img:"/static/qualityinsure/1200/5.jpg",text:"LED迷你控制器"},
        {img:"/static/qualityinsure/1200/6.jpg",text:"測驗報告"},
        {img:"/static/qualityinsure/1200/7.jpg",text:"LED電子看板防塵與防水測試報告"},
        {img:"/static/qualityinsure/1200/8.jpg",text:"測驗報告"},
        {img:"/static/qualityinsure/1200/9.jpg",text:"測驗報告"},
        {img:"/static/qualityinsure/1200/10.jpg",text:"測驗報告"},
        {img:"/static/qualityinsure/1200/11.jpg",text:"光磊測驗報告"},
        {img:"/static/qualityinsure/1200/12.jpg",text:"LED背光源防塵與防水測試報告"},
        {img:"/static/qualityinsure/1200/13.jpg",text:"LED電子看板防塵與防水測試報告"},

      ]
    }
  },
  methods: {
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    }
  },
  created: function() {
    this.pusha()
  },
  mounted: function() {

  },
}
</script>

<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"
.bar
  @include media-breakpoint-up(xl)
    margin-bottom: 50px
  @include media-breakpoint-up(xl)
    margin-bottom: 16px
.bg-n-red
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(182, 40 ,44)
  color: white
  text-align: center
  padding-top: 7px
  padding-bottom: 7px
.bg-n-gray
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(51, 58, 64)
  color: white
  padding-left: 13px
  padding-top: 7px
  padding-bottom: 7px 
#container-1
  @include media-breakpoint-up(xl)
    padding-top: 118px
    padding-bottom:  212px
  @include media-breakpoint-up(xs)
    padding-top: 46px
    padding-bottom:  146px
</style>




// WEBPACK FOOTER //
// src/components/QualityInsure.vue